import React, { useState } from 'react';

const COLORS = ['#ff6b6b','#ffd93d','#6bcb77','#4d96ff','#ff922b','#cc5de8','#f06595','#74c0fc','#a9e34b','#ff8787'];

export const Celebration = () => {
  const [particles] = useState(() =>
    Array.from({ length: 90 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      color: COLORS[i % COLORS.length],
      delay: Math.random() * 1.4,
      duration: 1.6 + Math.random() * 1.4,
      size: 7 + Math.random() * 11,
      isCircle: Math.random() > 0.4,
      spin: Math.random() > 0.5 ? 720 : -720,
    }))
  );

  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 9999, overflow: 'hidden' }}>
      <style>{`
        @keyframes confettiFall {
          0%   { opacity: 1; transform: translateY(-10px) rotate(0deg); }
          85%  { opacity: 1; }
          100% { opacity: 0; transform: translateY(105vh) rotate(var(--spin)); }
        }
      `}</style>

      {particles.map(p => (
        <div
          key={p.id}
          style={{
            position: 'absolute',
            left: `${p.left}%`,
            top: 0,
            width: p.size,
            height: p.isCircle ? p.size : p.size * 0.5,
            backgroundColor: p.color,
            borderRadius: p.isCircle ? '50%' : '2px',
            '--spin': `${p.spin}deg`,
            animationName: 'confettiFall',
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            animationTimingFunction: 'ease-in',
            animationFillMode: 'both',
          }}
        />
      ))}
    </div>
  );
};
